angular.module('unica_archive_media.archive_media_controllers')

.controller('ArchiveMediaListController', function(
	$rootScope, $scope, $state, $stateParams, $http, getBaseApiURL, Upload,
	$confirm, $uibModal, Lightbox,
	ArchiveMediaListService, ArchiveMediaDeleteService, ArchiveMediaEditService, MediaEditService
) {

	$scope.mediaList = [];
	$scope.limit  = 11;
	$scope.offset = 0;
	$scope.canLoad = true;
	$scope.event_id = $stateParams.event_id;
	$scope.directory_id = $stateParams.directory_id;

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getMediaDirectory( $stateParams.directory_id );

	$scope.tiles = [];
	//
	$scope.showDelete = true;

	//OLD METHOD
	$scope.uploadaAWS = function() {

		if($scope.fileAWS) {

			ArchiveMediaListService
				.getPresignedUrlPUT( $stateParams.event_id, $scope.fileAWS )
				.then(function(url) {

					Upload.upload(
						{
							url: url, //S3 upload url including bucket name
							method: 'PUT',
							headers: {
								'Content-Type': 'image/jpeg'
							},
							file: $scope.fileAWS
						}
					).progress(function(evt) {
						$scope.progressBar = parseInt(100.0 * evt.loaded / evt.total);
					}).success(function(data, status, headers, config) {
					}).error(function(err) {
						console.error(err.stack);
					});
				});
		}
		else {
			alert('No File Selected');
		}

	}


	$scope.loadMedia = function() {
		$scope.showLoader();
		$scope.canLoad = false;

		ArchiveMediaListService
			.list( $stateParams.event_id, $scope.directory_id, $scope.limit, $scope.offset )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.mediaList = $scope.mediaList.concat( data );

					$scope.tiles = $scope.tiles.concat( buildGridModel(data, {
						id: '', image : '', title: '', status: ''
					}) );

					if ( data.length === 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				}
			});
	};

	$scope.loadMedia();

	$scope.openMediaModal = function () {
		var modalInstance = $uibModal.open({
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			controller: 'ModalArchiveMediaInstanceController',
			controllerAs: '$ctrl',
			templateUrl: './templates/modals/archive-media.html',
			size: 'lg', 
			windowClass: 'modal-media'
		});

		modalInstance.result.then(function (data) {
			$scope.loadMedia();
		}, function () { });
	};

	$scope.openLightboxModal = function (index) {
		Lightbox.openModal($scope.mediaList, index);
	};

	$rootScope.$on( 'media_deleted', function(event, data) {

	});

	function buildGridModel(medias, tileTmpl) {
		var it,
			results = [ ],
			j = 0;

		angular.forEach(medias, function(md) {
			it = angular.extend({}, tileTmpl);
			it.id      		= md.id;
			it.image   		= md.thumb;
			it.title  		= md.orig_filename;
			it.type    		= ( md.type ? md.type : 'other');
			it.status  		= md.status;
			it.downloadable = md.downloadable;
			it.span    		= { row : 1, col : 1 };

			if ( j == 11 ) {
				j = 0;
			}

			switch ( j+1 ) {
				case 1:
					it.span.row = it.span.col = 2;
					break;
				case 4:
					it.span.col = 2;
					break;

				case 5:
					it.span.row = it.span.col = 2;
					break;
			}

			j++;

			results.push(it);
		});

		return results;
	}

	$scope.downloadMedia = function( id )
	{
		MediaEditService.addDownload(id);

		$scope.showNeutralMsg('Avvio download in corso..');
	};

	$scope.changeDownloadable = function( mediaId )
	{
		$scope.showLoader();
		ArchiveMediaEditService
			.changeDownloadable( mediaId )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {

					angular.forEach($scope.mediaList, function (media, key) {
						if (media.id === mediaId) {
							$scope.mediaList[key] = data;
						}
					});

					angular.forEach($scope.tiles, function (tile, key) {
						if (tile.id === mediaId) {
							tile.downloadable = data.downloadable;
							$scope.tiles[key] = tile;
						}
					});

				}

				$scope.showSuccessMsg('Modificato con successo!', '');
			});

	};


	$scope.deleteMedia = function(mediaId)
	{
		var media = null;
		angular.forEach($scope.mediaList, function(m, key) {
			if ( m.id === mediaId ) {
				media = m;
			}
		});

		$confirm({
			title: 'Sei sicuro di voler eliminare questo media?',
			text: 'Confermi la cancellazione del media?'
		}).then(function() {

			$scope.showLoader();
			ArchiveMediaDeleteService
				.delete( media.id  )
				.then(function() {
					$scope.hideLoader();

					angular.forEach($scope.mediaList, function(media, key) {
						if ( media.id === mediaId ) {
							$scope.mediaList.splice(key, 1);
						}
					});

					angular.forEach($scope.tiles, function(tile, key) {
						if ( tile.id === mediaId ) {
							$scope.tiles.splice(key, 1);
						}
					});

					$scope.showSuccessMsg('Media eliminato con successo!', '');
				});

		});
	};


	$scope.changeMediaStatus = function(mediaId)
	{
		var media = null;
		angular.forEach($scope.mediaList, function(m, key) {
			if ( m.id === mediaId ) {
				media = m;
			}
		});

		$scope.showLoader();

		var mediaData = {
			status: ( media.status === 'visible' ? 'hidden' : 'visible' )
		};

		MediaEditService
			.updateStatus( media.id, mediaData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					angular.forEach($scope.mediaList, function(m, key) {
						if (m.id === mediaId) {
							$scope.mediaList[key] = data;
						}
					});

					angular.forEach($scope.tiles, function(t, key) {
						if (t.id === mediaId) {
							t.status = data.status;
							$scope.tiles[key] = t;
						}
					});

					$scope.showSuccessMsg('Media aggiornato con successo!', '');
				}
			});
	};

})

.controller('ArchiveEventMediaListController', function(
	$rootScope, $scope, $state, $stateParams, $http, getBaseApiURL, Upload,
	$confirm, $uibModal, Lightbox,
	ArchiveMediaListService, ArchiveMediaDeleteService, ArchiveMediaEditService, MediaEditService
) {

	$scope.mediaList = [];
	$scope.limit  = 11;
	$scope.offset = 0;
	$scope.canLoad = true;
	$scope.event_id = $stateParams.event_id;
	$scope.directory_id = $stateParams.directory_id;

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getMediaDirectory( $stateParams.directory_id );

	$scope.tiles = [];
	//
	$scope.showDelete = false;

	//OLD METHOD
	$scope.uploadaAWS = function() {

		if($scope.fileAWS) {

			ArchiveMediaListService
				.getPresignedUrlPUT( $stateParams.event_id, $scope.fileAWS )
				.then(function(url) {

					Upload.upload(
						{
							url: url, //S3 upload url including bucket name
							method: 'PUT',
							headers: {
								'Content-Type': 'image/jpeg'
							},
							file: $scope.fileAWS
						}
					).progress(function(evt) {
						$scope.progressBar = parseInt(100.0 * evt.loaded / evt.total);
					}).success(function(data, status, headers, config) {
					}).error(function(err) {
						console.error(err.stack);
					});
				});
		}
		else {
			alert('No File Selected');
		}

	}


	$scope.loadMedia = function() {
		$scope.showLoader();
		$scope.canLoad = false;

		ArchiveMediaListService
			.list( $stateParams.event_id, $scope.directory_id, $scope.limit, $scope.offset )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.mediaList = $scope.mediaList.concat( data );

					$scope.tiles = $scope.tiles.concat( buildGridModel(data, {
						id: '', image : '', title: '', status: ''
					}) );

					if ( data.length === 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				}
			});
	};

	$scope.loadMedia();

	$scope.openMediaModal = function () {
		var modalInstance = $uibModal.open({
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			controller: 'ModalArchiveMediaInstanceController',
			controllerAs: '$ctrl',
			templateUrl: './templates/modals/archive-media.html',
			size: 'lg',
			windowClass: 'modal-media'
		});

		modalInstance.result.then(function (data) {
			$scope.loadMedia();
		}, function () { });
	};

	$scope.openLightboxModal = function (index) {
		Lightbox.openModal($scope.mediaList, index);
	};

	$rootScope.$on( 'media_deleted', function(event, data) {

	});

	function buildGridModel(medias, tileTmpl) {
		var it,
			results = [ ],
			j = 0;

		angular.forEach(medias, function(md) {
			it = angular.extend({}, tileTmpl);
			it.id      		= md.id;
			it.image   		= md.thumb;
			it.title  		= md.orig_filename;
			it.type    		= ( md.type ? md.type : 'other');
			it.status  		= md.status;
			it.downloadable = md.downloadable;
			it.span    		= { row : 1, col : 1 };

			if ( j == 11 ) {
				j = 0;
			}

			switch ( j+1 ) {
				case 1:
					it.span.row = it.span.col = 2;
					break;
				case 4:
					it.span.col = 2;
					break;

				case 5:
					it.span.row = it.span.col = 2;
					break;
			}

			j++;

			results.push(it);
		});

		return results;
	}

	$scope.downloadMedia = function( id )
	{
		MediaEditService.addDownload(id);

		$scope.showNeutralMsg('Avvio download in corso..');
	};

	$scope.changeDownloadable = function( mediaId )
	{
		$scope.showLoader();
		ArchiveMediaEditService
			.changeDownloadable( mediaId )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {

					angular.forEach($scope.mediaList, function (media, key) {
						if (media.id === mediaId) {
							$scope.mediaList[key] = data;
						}
					});

					angular.forEach($scope.tiles, function (tile, key) {
						if (tile.id === mediaId) {
							tile.downloadable = data.downloadable;
							$scope.tiles[key] = tile;
						}
					});

				}

				$scope.showSuccessMsg('Modificato con successo!', '');
			});

	};


	$scope.deleteMedia = function(mediaId)
	{
		var media = null;
		angular.forEach($scope.mediaList, function(m, key) {
			if ( m.id === mediaId ) {
				media = m;
			}
		});

		$confirm({
			title: 'Sei sicuro di voler eliminare questo media?',
			text: 'Confermi la cancellazione del media?'
		}).then(function() {

			$scope.showLoader();
			ArchiveMediaDeleteService
				.delete( media.id  )
				.then(function() {
					$scope.hideLoader();

					angular.forEach($scope.mediaList, function(media, key) {
						if ( media.id === mediaId ) {
							$scope.mediaList.splice(key, 1);
						}
					});

					angular.forEach($scope.tiles, function(tile, key) {
						if ( tile.id === mediaId ) {
							$scope.tiles.splice(key, 1);
						}
					});

					$scope.showSuccessMsg('Media eliminato con successo!', '');
				});

		});
	};


	$scope.changeMediaStatus = function(mediaId)
	{
		var media = null;
		angular.forEach($scope.mediaList, function(m, key) {
			if ( m.id === mediaId ) {
				media = m;
			}
		});

		$scope.showLoader();

		var mediaData = {
			status: ( media.status === 'visible' ? 'hidden' : 'visible' )
		};

		MediaEditService
			.updateStatus( media.id, mediaData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					angular.forEach($scope.mediaList, function(m, key) {
						if (m.id === mediaId) {
							$scope.mediaList[key] = data;
						}
					});

					angular.forEach($scope.tiles, function(t, key) {
						if (t.id === mediaId) {
							t.status = data.status;
							$scope.tiles[key] = t;
						}
					});

					$scope.showSuccessMsg('Media aggiornato con successo!', '');
				}
			});
	};

})


.controller('ModalArchiveMediaInstanceController',
	function (
		$scope, $stateParams, $rootScope, ArchiveMediaListService, $http,
		$uibModalInstance, getBaseApiURL, Session, Upload 
	) {
	
	$scope.mediaData = {
		files: [],
		infofiles: [],
		progress: 0,
		uploading: 0,
	};

	// $scope.mediaType = mediaType;
	$scope.uploadDone = false;
	$scope.enableUploadAll = 0;

	$scope.addMediaFiles = function(files) {
		files.forEach( function(file) {
			$scope.enableUploadAll++;
			file.progress = 0;
			file.isReady = false;
			file.isUploading = false;
			file.isSuccess = false;
			$scope.mediaData.files.push(file);
			calcolateProgressBar();
		});
	}

	function calcolateProgressBar() {
		var tmpSum = 0;
		$scope.mediaData.files.forEach(function(file) {
			if ( file.progress ) {
				tmpSum += file.progress;
			}
		});
		$scope.mediaData.progress = Math.floor( tmpSum / $scope.mediaData.files.length );
		$scope.$apply();

	}

	$scope.uploadAll = function() {
		for ( i = 0; i < $scope.mediaData.files.length; i++ ) {
			var tmpFile = $scope.mediaData.files[i];
			if ( !tmpFile.isUploading && !tmpFile.isSuccess && tmpFile.isReady ) {
				$scope.uploadItem(i);
			}
		}
	}

	var bucketRegion = "eu-central-1";
	AWS.config.update({
		region: bucketRegion,
	});

	$scope.uploadItem = function(i) {
		//upload file

		ArchiveMediaListService
			.getPresignedUrlPUT( $stateParams.event_id, $scope.mediaData.files[i] )
			.then(function(data) {

				var credentials = new AWS.Credentials({
					accessKeyId : data.accessKey,
					secretAccessKey: data.secret,
					sessionToken: data.token
				});

				var service = new AWS.S3({ credentials: credentials });
				var managedUpload = new AWS.S3.ManagedUpload({
					params: {
						Bucket: data.Bucket,
						Key: data.Key,
						Body: $scope.mediaData.files[i]
					},
					service: service
				});
				$scope.mediaData.files[i].awsName = data.Key;
				managedUpload.send();
				managedUpload.promise().then(function () {

					$scope.mediaData.files[i]['progress'] = 100;
					if ( $scope.mediaData.files[i]['isUploading'] ){ //decremento solo se era stato aumentato
						$scope.mediaData.uploading--;
					}
					$scope.mediaData.files[i]['isUploading'] = false;
					$scope.mediaData.files[i]['isSuccess'] = true;

					$scope.enableUploadAll--;
					$scope.uploadDone = true;

					calcolateProgressBar();

					ArchiveMediaListService
						.saveArchive($stateParams.event_id, $stateParams.directory_id, $scope.mediaData.files[i])
						.then(function(ret) {

						});

				},function(err) {
					console.error(err);
				});

				managedUpload.on('httpUploadProgress', function (progress) {
					if ( !$scope.mediaData.files[i]['isUploading'] ){ //incremento solo la prima volta
						$scope.mediaData.uploading++;
					}
					$scope.mediaData.files[i]['isUploading'] = true;
					//
					$scope.mediaData.files[i]['progress'] =  parseInt((progress.loaded / progress.total) * 100);
					calcolateProgressBar();
				})

			});

	}

	$scope.abortItem = function(i) {
		if ( $scope.mediaData.files[i].upload ) {
			$scope.mediaData.files[i].upload.abort(); 
			if ( $scope.mediaData.files[i]['isUploading'] ){ //decremento solo se era stato aumentato
				$scope.mediaData.uploading--;
			}
			$scope.mediaData.files[i]['isUploading'] = false;
			$scope.mediaData.files[i].progress = 0; 
			calcolateProgressBar();
		} 
	};

	$scope.removeItem = function(i) {
		$scope.mediaData.files.splice(i, 1);
	}

	$scope.closeModal = function() {
		if ( $scope.uploadDone ) {
			$uibModalInstance.close();
		} else {
			$uibModalInstance.dismiss('cancel');
		}
	};

	$scope.triggerInput = function() {
		setTimeout(function() {
			document.getElementById('files').click()
		}, 0);
	};

	$scope.showDelete = true;
	if ( sessionStorage.getItem('sub_from_admin_archive') ) {
		sessionStorage.removeItem('sub_from_admin_archive');
		$scope.showDelete = false;
	}

})

.controller('LightboxController', function ($rootScope, $scope, Lightbox) {
	
});